import { ReportImport } from './Imports'
const { RoutesMap, FarmReport, CropPlaningReport, ConstructionReport } = ReportImport

const ReportRoute = () => {
    return [
        {
            path: RoutesMap.FARM_REPORT.path,
            element: <FarmReport />
        },
        {
            path: RoutesMap.CROP_PLANING_REPORT.path,
            element: <CropPlaningReport />
        },
        {
            path: RoutesMap.CONSTRUCTION_REPORT.path,
            element: <ConstructionReport />
        },
    ]
}

export default ReportRoute;